import axios from "axios";

const AccessPointService = {

    getAll: async function (filters) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points?'+filters)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                access_points: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    getOne: async function (accessPointId) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/access_points/${accessPointId}`)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                access_point: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    create: async function (params) {
        try {
            const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/', params)
            return response.data.data;
        } catch (e) {
            console.log(e);
            return {
                access_point: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    update: async function (accessPointId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/' + accessPointId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                access_point: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    updateConfig: async function (optionId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/configs/' + optionId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    deletePage: async function (accessPointId) {
        if (confirm("Are you sure you want to delete this access point?.")) {
            try {
                const response = await axios.delete(process.env.VUE_APP_SERVER_URL + `/api/v1/access_points/${accessPointId}`)
                return response.data.data.message
            } catch (e) {
                console.log(e.message);
                return {
                    access_point: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    },

};

export default AccessPointService;